import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DialogEditBadge',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible(newValue) {
      if (!newValue) {
        // reset fields
        this.badgeCode = '';
      }
    },
  },
  emits: ['hide-dialog', 'save-badge'],
})
export default class DialogEditBadge extends Vue {
  badgeCode!: string;
  isVisible?: boolean;

  handleHideDialog() {
    this.$emit('hide-dialog');
  }

  async handleButtonSubmitAction() {
    this.$emit('save-badge', this.badgeCode);
  }
}
